<template>
<!-- Start of Modal -->
<div class="modal">
  <!--input id="modal_trigger" type="checkbox"/>
  <label for="modal_trigger">1</label-->
  <div class="modal_overlay" :class="{ showfiche: infos.length>0}">
    <div class="modal_wrap">
      <div class="modal_header">
        <div class="modal_header_title">
          <p>{{ $t("message['Informations disponibles']")}}</p>
          <label for="modal_trigger" @click="close" class="close_modal"></label>
        </div>
        <hr />
      </div>
      <div class="modal_tabs">
        <button id="tab_supports" v-if="infos.length>1" @click="changeModalTabs" class="modal_tab tab_supports_et_mesures active">Sites</button>
        <button id="tab_support" @click="changeModalTabs" class="modal_tab tab_support hidetab">Site {{info.numero}}</button>
        <button id="tab_antennes" @click="changeModalTabs" class="modal_tab tab_antennes hidetab">{{ $tc("message['Sites radioélectriques']",2)}}</button>
      </div>
      <div class="modal_all_content">
        <!-- Contenu SUPPORTS ET MESURES  -->
        <div id="modal_supports" v-if="infos.length>1" class="modal_content modal_content_supports_et_mesures active">
          <p class="modal_subtitle">{{infos.length}} {{ $t("message['sites trouvés']")}}</p>
          <div class="modal_list_tab">
            <div class="modal_list_item" v-for="(support, index) in infos" :key="index">
              <p class="link" @click="changeModalTabsFromId(support)">{{support.numero}}</p>
              <p>{{support.description.nature}} / {{roundHauteur(support.description.hauteur)}}m / {{support.description.proprietaire}}</p>
              <p>{{support.adresse.adresse}} {{support.adresse.lieu_dit}}
                <br />{{support.adresse.codepostal}} {{support.adresse.commune}}</p>
            </div>
          </div>
          <div class="conditions">
            <p class="conditions_title">Edition {{ $t("message['du']")}} {{date}}</p>
            <p class="conditions_subtitle">{{ $t("message['Pour une meilleure compréhension de cette fiche, consultez le']")}}
              <a :href="this.urlGlossaire" target="_blank">{{ $t("message['Glossaire']") }}</a> {{ $t("message['et la']")}}
              <a :href="this.urlFAQ" target="_blank">{{ $t("message['FAQ']") }}</a>.
              <br />
              <span v-if="$root.$i18n.locale === 'en'">In case of error, please.<a href="http://faq.anfr.fr/" target="_blank" class="link"> contact us</a></span>
              <span v-else><a href="http://faq.anfr.fr/" target="_blank" class="link">Nous contacter</a> en cas d'erreur </span></p>
            <p class="conditions_text">{{ $t("message['Ces informations relatives etc.']")}}.</p>
          </div>
        </div>
        <!-- Contenu SUPPORT  -->
        <div id="modal_support" class="modal_content modal_content_support">
          <p class="modal_subtitle">{{ $t("message['Détail du site']")}} :</p>
          <div class="support_detail">
            <p><span>N° identification : </span>{{ info.numero }}</p>
            <p><span>{{ $t("message['Description du site']")}} : </span>{{description.nature}} / {{roundHauteur(description.hauteur)}}m / {{description.proprietaire}}</p>
            <p><span>{{ $t("message['Adresse']")}} : </span>{{adresse.adresse}} {{adresse.lieu_dit}}</p>
            <p><span>{{ $t("message['Code Postal / Commune']")}} : </span>{{adresse.code_postal}} {{adresse.commune}}</p>
            <p><span>{{ $t("message['Coordonnées']")}} : </span>{{coordonnees.coord_x}}, {{coordonnees.coord_y}}</p>
          </div>
          <div class="modal_subtitle" v-for="(categorie, index) in categories" :key="index">
            <div>{{categorie.nom}}</div>
            <div class="modal_list_operateurs">
              <div class="modal_list_operateurs_item" v-for="(exploitant, index) in categorie.exploitants" :key="index">
                <img class="exploitant" :src="`/static/img/operateurs/logos/logo-${(exploitant.id)}.png`" :alt="exploitant.nom" :title="exploitant.nom"
                  onError="var ua=window.navigator.userAgent;if (ua.indexOf('MSIE ')>=0||ua.indexOf('Trident/')>=0) { this.src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=' }" />
                <p class="link" @click="changeModalTabsFromSystem(exploitant, categorie)">{{formatSystemes(exploitant.systemes)}}</p>
              </div>
            </div>
          </div>
          <div class="conditions">
            <p class="conditions_title">Edition {{ $t("message['du']")}} {{date}}</p>
            <p class="conditions_subtitle">{{ $t("message['Pour une meilleure compréhension de cette fiche, consultez le']")}}
              <a :href="this.urlGlossaire" target="_blank">{{ $t("message['Glossaire']") }}</a> {{ $t("message['et la']")}}
              <a :href="this.urlFAQ" target="_blank">{{ $t("message['FAQ']") }}</a>.
              <br />
              <span v-if="$root.$i18n.locale === 'en'">In case of error, please.<a href="http://faq.anfr.fr/" target="_blank" class="link"> contact us</a></span>
              <span v-else><a href="http://faq.anfr.fr/" target="_blank" class="link">Nous contacter</a> en cas d'erreur </span></p>
            <p class="conditions_text">{{ $t("message['Ces informations relatives etc.']")}}.</p>
          </div>
        </div>

        <!-- Contenu ANTENNES  -->
        <div id="modal_antennes" class="modal_content modal_content_antennes">
          <div class="support_detail">
            <table>
              <tr>
                <td>
                  <p class="op_bouygues"><span>{{ $tc("message['Opérateur']", 1)}} : </span>{{exploitant.nom}}</p>
                  <p><span>{{ $t("message['Catégorie']")}} : </span> {{categorie.nom}}</p>
                  <p><span>{{ $t("message['Adresse']")}} : </span>{{adresse.adresse}}</p>
                  <p><span>{{ $t("message['Code Postal / Commune']")}}  : </span>{{adresse.code_postal}} {{adresse.commune}}</p>
                  <p><span>{{ $t("message['Coordonnées']")}} : </span>{{coordonnees.coord_x}}, {{coordonnees.coord_y}}</p>
                </td>
              </tr>
            </table>
          </div>
          <p class="modal_subtitle">{{ $t("message['Détail des antennes']")}} :</p>
          <div v-for="(station, index) in stations" :key="index">
            <div class="modal_detail_station">
              <p><span>{{ $t("message['N° de station ANFR']")}} : </span>{{station.station.anfr}}</p>
              <p>
                <span>{{ $t("message['Date de mise en service']")}} : </span>{{station.station.service}}
                <span v-if="station.station.modification !== undefined">{{ '&nbsp;&nbsp;-&nbsp;&nbsp;' +$t("message['Date de dernière modification']")}}  : </span>{{station.station.modification}}
              </p>
            </div>
            <div class="modal_list_tab" v-for="(installation, index) in station.installations" :key="index">
              <div class="modal_list_item_title">
                {{ $t("message['Hauteur']")}} : {{roundHauteur(installation.hauteur)}} Mètres
              </div>
              <div class="modal_table_antennes">
                <table>
                  <template v-for="(antenne) in installation.antennes">
                    <thead :key="antenne.id + 'A'">
                      <tr>
                        <th>
                          <div class="modal_list_header_antenne">
                            <span>{{$t("message['N° antenne']")}}</span>
                          </div>
                        </th>
                        <th>
                          <div class="modal_list_header_antenne">
                            <span>{{$t("message['Orientations']")}}</span>
                          </div>
                        </th>
                        <th>
                          <div class="modal_list_header_antenne">
                            <span>{{$t("message['Emetteurs']")}}</span>
                          </div>
                        </th>
                        <th v-if="station.categorie.code === 'TEL'">
                          <div class="modal_list_header_antenne">
                            <span>{{$t("message['Dates de mises en service']")}}</span>
                          </div>
                        </th>
                        <th>
                          <div class="modal_list_header_antenne">
                            <span>{{$t("message['Bandes de fréquences']")}}</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody :key="antenne.id">
                    <tr v-for="(emetteur, indexAntenne) in reorderSystemes(antenne.emetteurs)" :key="emetteur.id + indexAntenne"
                      v-bind:class="{inter_antenne: indexAntenne===antenne.emetteurs.length - 1}">
                      <td>
                        <div class="modal_list_item_antenne" v-if="indexAntenne===0">
                          <p>{{antenne.id}}</p>
                        </div>
                      </td>
                      <td>
                        <div class="modal_list_item_antenne" v-if="indexAntenne===0">
                          <p v-if="antenne.orientation != null">{{antenne.orientation + '°'}}</p>
                        </div>
                      </td>
                      <td class="modal_table_border_bottom">
                        <div class="modal_list_item_antenne">
                          <p>{{emetteur.systeme}}</p>
                        </div>
                      </td>
                      <td v-if="station.categorie.code === 'TEL'" class="modal_table_border_bottom">
                        <div class="modal_list_item_antenne">
                          <p>{{emetteur.date_service}}</p>
                        </div>
                      </td>
                      <td class="modal_table_border_bottom">
                        <div class="modal_list_item_antenne">
                          <p v-for="(bande, indexBande) in reorderBandes(emetteur.bandes)" :key="indexBande">
                            {{ bande.debut == undefined ? '' : bande.debut + '-' + bande.fin + ' '+ bande.unite + 'Hz'}}
                          </p>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </table>
              </div>
            </div>
          </div>
          <div class="conditions">
            <p class="conditions_title">Edition {{ $t("message['du']")}} {{date}}</p>
            <p class="conditions_subtitle">{{ $t("message['Pour une meilleure compréhension de cette fiche, consultez le']")}}
              <a :href="this.urlGlossaire" target="_blank">{{ $t("message['Glossaire']") }}</a> {{ $t("message['et la']")}}
              <a :href="this.urlFAQ" target="_blank">{{ $t("message['FAQ']") }}</a>.
              <br />
              <span v-if="$root.$i18n.locale === 'en'">In case of error, please.<a href="http://faq.anfr.fr/" target="_blank" class="link"> contact us</a></span>
              <span v-else><a href="http://faq.anfr.fr/" target="_blank" class="link">Nous contacter</a> en cas d'erreur </span></p>
            <p class="conditions_text">{{ $t("message['Ces informations relatives etc.']")}}.</p>
          </div>
        </div>
      </div>

      <!-- MODAL FOOTER -->
      <div class="modal_footer">
        <div class="modal_footer_btn">
          <label @click="print" v-if="printable" class="print_modal"><span>{{ $tc("message['Imprimer / Télécharger']")}}</span></label>
          <label for="modal_trigger" @click="close" class="close_modal"><span>Fermer</span></label>
        </div>
      </div>
    </div>
  </div>
</div>
<!--End of Modal -->
</template>

<script>
import axios from 'axios'
import _ from 'lodash'

import FichePrinter from './print/FichePrinter'

export default {
  name: 'FicheSupport',
  data() {
    return {
      infos: [],
      info: [],
      exploitant: [],
      exploitants: [],
      installations: [],
      stations: [],
      description: {},
      adresse: {},
      coordonnees: {},
      categorie: [],
      categories: [],
      date: new Date().toLocaleDateString(),
      printable: false,
      categoriesFilter: [],
      systemesFilter: [],
      operateursFilter: [],
      operateursNotFilter: [],
      operateurAutreFilter: null,
      technologiesFilter: []

    }
  },
  computed: {
    urlFAQ() {
      return this.$store.state.paramUrl.URL_FAQ ? this.$store.state.paramUrl.URL_FAQ : ''
    },
    urlGlossaire() {
      return this.$store.state.paramUrl.URL_GLOSSAIRE ? this.$store.state.paramUrl.URL_GLOSSAIRE : ''
    }
  },
  filters: {
    decimals: function(value) {
      var val = String(value)
      return val.match(/([0-9]*)(.?)([0-9]?)/g)[0]
    }
  },
  methods: {
    systemCombin: function(systems) {
      let combin = ''
      _.forEach(systems, function(system) {
        _.forEach(system, function(systeme) {
          combin = combin + systeme.systeme + '/'
        })
      })
      return combin
    },
    close: function() {
      var tabSupportsEtMesures = document.getElementById('tab_supports')
      var tabSupport = document.getElementById('tab_support')
      var tabAntennes = document.getElementById('tab_antennes')
      var modalContentSupportsEtMesures = document.getElementById('modal_supports')
      var modalContentSupport = document.getElementById('modal_support')
      var modalContentAntennes = document.getElementById('modal_antennes')
      if (tabSupportsEtMesures && modalContentSupportsEtMesures) {
        tabSupportsEtMesures.classList.add('active')
        modalContentSupportsEtMesures.classList.add('active')
      }
      tabSupport.classList.remove('active')
      tabAntennes.classList.remove('active')
      tabSupport.classList.add('hidetab')
      tabAntennes.classList.add('hidetab')
      modalContentSupport.classList.remove('active')
      modalContentAntennes.classList.remove('active')
      this.infos = []
      this.info = []
      this.printable = false
    },
    loadSupports: function(hashes, categories, systemes, operateurs, operateursNot, operateurAutre, technologies) {
      this.categoriesFilter = categories
      this.systemesFilter = systemes
      this.operateursFilter = operateurs
      this.operateursNotFilter = operateursNot
      this.operateurAutreFilter = operateurAutre
      this.technologiesFilter = technologies
      axios.get('/api/v1/sites', {
        params: {
          'format': 'json',
          'numeros': hashes
        }
      })
        .then((response) => {
          let returned = []
          _.forEach(response.data.sites, function(support) {
            // support.categories = Array.isArray(support.categories.categorie) ? support.categories.categorie : [support.categories.categorie]
            returned.push(support)
          })
          return returned
        })
        .then((supports) => {
          this.infos = supports
          var tabSupports = document.getElementById('tab_supports')
          var tabSupport = document.getElementById('tab_support')
          var tabAntennes = document.getElementById('tab_antennes')
          var modalContentSupports = document.getElementById('modal_supports')
          var modalContentSupport = document.getElementById('modal_support')
          var modalContentAntennes = document.getElementById('modal_antennes')

          if (this.infos.length === 1) {
            this.info = this.infos[0]
            axios.get('/api/v1/sites/' + this.info.numero, {
              params: {
                'categories': this.categoriesFilter,
                'operateurs': this.operateursFilter,
                'operateursnot': this.operateursNotFilter,
                'operateurautre': this.operateurAutreFilter,
                'technologies': this.technologiesFilter,
                'systemes': this.systemesFilter
              }
            }).then((response) => {
              if (response.data.data) {
                this.categories = _.orderBy(response.data.data.categories, 'nom', 'desc')
                this.description = response.data.data.description
                this.adresse = response.data.data.adresse
                this.coordonnees = response.data.data.coordonnees
              }
            })
            tabSupport.classList.add('active')
            tabSupport.classList.remove('hidetab')
            modalContentSupport.classList.add('active')
            tabAntennes.classList.remove('active')
            tabAntennes.classList.add('hidetab')
            modalContentAntennes.classList.remove('active')
            this.printable = true
          } else {
            if (tabSupport && modalContentSupport) {
              tabSupport.classList.remove('active')
              tabSupport.classList.add('hidetab')
              modalContentSupport.classList.remove('active')
            }
            if (tabAntennes && modalContentAntennes) {
              tabAntennes.classList.remove('active')
              tabAntennes.classList.add('hidetab')
              modalContentAntennes.classList.remove('active')
            }
            if (tabSupports && modalContentSupports) {
              tabSupports.classList.add('active')
              tabSupports.classList.remove('hidetab')
              modalContentSupports.classList.add('active')
            }
          }
        })
    },
    findLogo: function(text) {
      text = text != null ? text.replace(/ /g, '_') : ''
      return text
    },
    roundHauteur(hauteur) {
      return Math.round(hauteur * 100) / 100
    },
    changeModalTabsFromId: function(support) {
      var tabSupportsEtMesures = document.getElementById('tab_supports')
      var tabSupport = document.getElementById('tab_support')
      var tabAntennes = document.getElementById('tab_antennes')
      var modalContentSupportsEtMesures = document.getElementById('modal_supports')
      var modalContentSupport = document.getElementById('modal_support')
      var modalContentAntennes = document.getElementById('modal_antennes')
      this.info = support
      axios.get('/api/v1/sites/' + support.numero, {
        params: {
          'categories': this.categoriesFilter,
          'operateurs': this.operateursFilter,
          'operateursnot': this.operateursNotFilter,
          'operateurautre': this.operateurAutreFilter,
          'technologies': this.technologiesFilter,
          'systemes': this.systemesFilter
        }
      }).then((response) => {
        if (response.data.data) {
          this.categories = _.orderBy(response.data.data.categories, 'nom', 'desc')
          this.description = response.data.data.description
          this.adresse = response.data.data.adresse
        }
      })
      if (tabSupportsEtMesures && modalContentSupportsEtMesures) {
        tabSupportsEtMesures.classList.remove('active')
        modalContentSupportsEtMesures.classList.remove('active')
      }
      tabSupport.classList.add('active')
      tabSupport.classList.remove('hidetab')
      modalContentSupport.classList.add('active')
      this.printable = true
      tabAntennes.classList.remove('active')
      modalContentAntennes.classList.remove('active')
    },
    changeModalTabsFromSystem: function(exploitant, categorie) {
      var tabSupportsEtMesures = document.getElementById('tab_supports')
      var tabSupport = document.getElementById('tab_support')
      var tabAntennes = document.getElementById('tab_antennes')
      var modalContentSupportsEtMesures = document.getElementById('modal_supports')
      var modalContentSupport = document.getElementById('modal_support')
      var modalContentAntennes = document.getElementById('modal_antennes')
      this.exploitant = exploitant
      this.categorie = categorie
      axios.get('/api/v1/sites/' + this.info.numero + '/antennes', {
        params: {
          'categorie': categorie.code,
          'operateur': exploitant.id,
          'technologies': categorie.code === 'TEL' ? exploitant.systemes : null
        }
      }).then((response) => {
        if (response.data) {
          this.stations = response.data.data
        }
      })
      if (tabSupportsEtMesures && modalContentSupportsEtMesures) {
        tabSupportsEtMesures.classList.remove('active')
        modalContentSupportsEtMesures.classList.remove('active')
      }
      tabSupport.classList.remove('active')
      modalContentSupport.classList.remove('active')
      tabAntennes.classList.add('active')
      tabAntennes.classList.remove('hidetab')
      modalContentAntennes.classList.add('active')
    },
    changeModalTabs: function(event) {
      var elt = event.target
      var tabSupportsEtMesures = document.getElementById('tab_supports')
      var tabSupport = document.getElementById('tab_support')
      var tabAntennes = document.getElementById('tab_antennes')
      var modalContentSupportsEtMesures = document.getElementById('modal_supports')
      var modalContentSupport = document.getElementById('modal_support')
      var modalContentAntennes = document.getElementById('modal_antennes')

      if (elt.classList.contains('tab_supports_et_mesures')) {
        if (tabSupportsEtMesures && modalContentSupportsEtMesures) {
          tabSupportsEtMesures.classList.add('active')
          modalContentSupportsEtMesures.classList.add('active')
          this.printable = false
        }
        tabSupport.classList.remove('active')
        modalContentSupport.classList.remove('active')
        tabAntennes.classList.remove('active')
        tabAntennes.classList.add('hidetab')
        modalContentAntennes.classList.remove('active')
      } else if (elt.classList.contains('tab_support')) {
        if (tabSupportsEtMesures && modalContentSupportsEtMesures) {
          tabSupportsEtMesures.classList.remove('active')
          modalContentSupportsEtMesures.classList.remove('active')
        }
        tabSupport.classList.add('active')
        modalContentSupport.classList.add('active')
        this.printable = true
        tabAntennes.classList.remove('active')
        tabAntennes.classList.add('hidetab')

        modalContentAntennes.classList.remove('active')
      } else if (elt.classList.contains('tab_antennes')) {
        if (tabSupportsEtMesures && modalContentSupportsEtMesures) {
          tabSupportsEtMesures.classList.remove('active')
          modalContentSupportsEtMesures.classList.remove('active')
        }
        tabSupport.classList.remove('active')
        modalContentSupport.classList.remove('active')
        tabAntennes.classList.add('active')
        this.printable = true
        modalContentAntennes.classList.add('active')
      }
    },

    reorderBandes: function(bandes) {
      return _.orderBy(bandes, (e) => parseFloat(e.debut), 'desc')
    },

    reorderSystemes: function(systemes) {
      return _.orderBy(systemes, (e) => parseFloat(e.ordre), 'desc')
    },

    print: function() {
      let element = document.getElementById('modal_support').parentElement.getElementsByClassName('active')[0]
      new FichePrinter(element).execute(this.info.numero)
    },

    formatSystemes: function(systemes) {
      return systemes.toString().replaceAll(',', '/')
    }
  }
}
</script>
<style scoped>
/* Gestion des images non trouvées */

img.exploitant {
  position: relative;
  display: block;
  overflow: hidden;
  word-wrap: break-word;
}

img[alt].exploitant:after {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  background-color: #efefef;
  border: solid 1px #57575773;
  color: #5757578a;
  content: attr(alt);
  font-style: italic;
}
</style>
